export enum DialogTemplateButtonComboStyleEnum {
  OUTLINE = 'outline',
  FILL_PRIMARY = 'fill-primary',
  FILL_ACCENT = 'fill-accent',
  FILL_ERROR = 'fill-error',
  FILL_GRADIENT_1 = 'fill-gradient-1'
}
